import { FCX } from "@datassential/platform-ui-lib";
import SectionSocial from "@pages/Food/legacy/components/SectionSocial/SectionSocial";
import SectionsDocuments from "@pages/Food/legacy/components/SectionsDocuments/SectionsDocuments";
import useFoodProfilePage from "@pages/Food/hooks/useFoodProfilePage";
import "@pages/Food/Food.sections.scss";

type Props = Pick<
    ReturnType<typeof useFoodProfilePage>["sections"],
    "summary" | "setHasSocial" | "setHasReports" | "setHasCharts"
>;

/**
 * The legacy page's Social, Reports and Charts sections.
 * Menu, Consumer and Launches are laid out by `FoodLegacy` itself; the refreshed page uses `FoodRefreshSections`.
 */
const FoodProfileSections: FCX<Props> = ({
    summary,
    setHasSocial,
    setHasReports,
    setHasCharts,
}) => (
    <>
        {!!summary.id && (
            <SectionSocial
                setHasData={setHasSocial}
                word={summary.name}
                wordId={summary.id}
            />
        )}
        <SectionsDocuments
            word={summary.name}
            setHasReports={setHasReports}
            setHasCharts={setHasCharts}
        />
    </>
);

export default FoodProfileSections;
